var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 420,
    viewBox: "0 0 166 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1357_7745)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1357_7745)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint0_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint1_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 25.417C40.6904 25.417 41.25 25.9766 41.25 26.667L41.25 50.3159L49.1161 42.4498C49.6043 41.9616 50.3957 41.9616 50.8839 42.4498C51.372 42.9379 51.372 43.7294 50.8839 44.2175L40.8839 54.2175C40.6495 54.452 40.3315 54.5837 40 54.5837C39.6685 54.5837 39.3505 54.452 39.1161 54.2175L29.1161 44.2175C28.628 43.7294 28.628 42.9379 29.1161 42.4498C29.6043 41.9616 30.3957 41.9616 30.8839 42.4498L38.75 50.3159L38.75 26.667C38.75 25.9766 39.3096 25.417 40 25.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    y: 85,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 85,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint2_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 85.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint3_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 110.417C40.6904 110.417 41.25 110.977 41.25 111.667L41.25 135.316L49.1161 127.45C49.6043 126.962 50.3957 126.962 50.8839 127.45C51.372 127.938 51.372 128.729 50.8839 129.218L40.8839 139.218C40.6495 139.452 40.3315 139.584 40 139.584C39.6685 139.584 39.3505 139.452 39.1161 139.218L29.1161 129.218C28.628 128.729 28.628 127.938 29.1161 127.45C29.6043 126.962 30.3957 126.962 30.8839 127.45L38.75 135.316L38.75 111.667C38.75 110.977 39.3096 110.417 40 110.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint4_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 170.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint5_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 195.417C40.6904 195.417 41.25 195.977 41.25 196.667L41.25 220.316L49.1161 212.45C49.6043 211.962 50.3957 211.962 50.8839 212.45C51.372 212.938 51.372 213.729 50.8839 214.218L40.8839 224.218C40.6495 224.452 40.3315 224.584 40 224.584C39.6685 224.584 39.3505 224.452 39.1161 224.218L29.1161 214.218C28.628 213.729 28.628 212.938 29.1161 212.45C29.6043 211.962 30.3957 211.962 30.8839 212.45L38.75 220.316L38.75 196.667C38.75 195.977 39.3096 195.417 40 195.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    y: 255,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 255,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint6_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 255.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint7_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 280.417C40.6904 280.417 41.25 280.977 41.25 281.667L41.25 305.316L49.1161 297.45C49.6043 296.962 50.3957 296.962 50.8839 297.45C51.372 297.938 51.372 298.729 50.8839 299.218L40.8839 309.218C40.6495 309.452 40.3315 309.584 40 309.584C39.6685 309.584 39.3505 309.452 39.1161 309.218L29.1161 299.218C28.628 298.729 28.628 297.938 29.1161 297.45C29.6043 296.962 30.3957 296.962 30.8839 297.45L38.75 305.316L38.75 281.667C38.75 280.977 39.3096 280.417 40 280.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    y: 340,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 340,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint8_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 340.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint9_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 365.417C40.6904 365.417 41.25 365.977 41.25 366.667L41.25 390.316L49.1161 382.45C49.6043 381.962 50.3957 381.962 50.8839 382.45C51.372 382.938 51.372 383.729 50.8839 384.218L40.8839 394.218C40.6495 394.452 40.3315 394.584 40 394.584C39.6685 394.584 39.3505 394.452 39.1161 394.218L29.1161 384.218C28.628 383.729 28.628 382.938 29.1161 382.45C29.6043 381.962 30.3957 381.962 30.8839 382.45L38.75 390.316L38.75 366.667C38.75 365.977 39.3096 365.417 40 365.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint10_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint11_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 25.417C126.69 25.417 127.25 25.9766 127.25 26.667L127.25 50.3159L135.116 42.4498C135.604 41.9616 136.396 41.9616 136.884 42.4498C137.372 42.9379 137.372 43.7294 136.884 44.2175L126.884 54.2175C126.649 54.452 126.332 54.5837 126 54.5837C125.668 54.5837 125.351 54.452 125.116 54.2175L115.116 44.2175C114.628 43.7294 114.628 42.9379 115.116 42.4498C115.604 41.9616 116.396 41.9616 116.884 42.4498L124.75 50.3159L124.75 26.667C124.75 25.9766 125.31 25.417 126 25.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 85,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 85,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint12_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 85.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint13_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 110.417C126.69 110.417 127.25 110.977 127.25 111.667L127.25 135.316L135.116 127.45C135.604 126.962 136.396 126.962 136.884 127.45C137.372 127.938 137.372 128.729 136.884 129.218L126.884 139.218C126.649 139.452 126.332 139.584 126 139.584C125.668 139.584 125.351 139.452 125.116 139.218L115.116 129.218C114.628 128.729 114.628 127.938 115.116 127.45C115.604 126.962 116.396 126.962 116.884 127.45L124.75 135.316L124.75 111.667C124.75 110.977 125.31 110.417 126 110.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 170,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 170,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint14_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 170.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint15_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 195.417C126.69 195.417 127.25 195.977 127.25 196.667L127.25 220.316L135.116 212.45C135.604 211.962 136.396 211.962 136.884 212.45C137.372 212.938 137.372 213.729 136.884 214.218L126.884 224.218C126.649 224.452 126.332 224.584 126 224.584C125.668 224.584 125.351 224.452 125.116 224.218L115.116 214.218C114.628 213.729 114.628 212.938 115.116 212.45C115.604 211.962 116.396 211.962 116.884 212.45L124.75 220.316L124.75 196.667C124.75 195.977 125.31 195.417 126 195.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 255,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 255,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint16_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 255.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint17_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 280.417C126.69 280.417 127.25 280.977 127.25 281.667L127.25 305.316L135.116 297.45C135.604 296.962 136.396 296.962 136.884 297.45C137.372 297.938 137.372 298.729 136.884 299.218L126.884 309.218C126.649 309.452 126.332 309.584 126 309.584C125.668 309.584 125.351 309.452 125.116 309.218L115.116 299.218C114.628 298.729 114.628 297.938 115.116 297.45C115.604 296.962 116.396 296.962 116.884 297.45L124.75 305.316L124.75 281.667C124.75 280.977 125.31 280.417 126 280.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 340,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#EDE8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 340,
    width: 80,
    height: 80,
    rx: 16,
    fill: "url(#paint18_linear_1357_7745)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5,
    y: 340.5,
    width: 79,
    height: 79,
    rx: 15.5,
    stroke: "url(#paint19_linear_1357_7745)",
    strokeOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 365.417C126.69 365.417 127.25 365.977 127.25 366.667L127.25 390.316L135.116 382.45C135.604 381.962 136.396 381.962 136.884 382.45C137.372 382.938 137.372 383.729 136.884 384.218L126.884 394.218C126.649 394.452 126.332 394.584 126 394.584C125.668 394.584 125.351 394.452 125.116 394.218L115.116 384.218C114.628 383.729 114.628 382.938 115.116 382.45C115.604 381.962 116.396 381.962 116.884 382.45L124.75 390.316L124.75 366.667C124.75 365.977 125.31 365.417 126 365.417Z",
    fill: "#9F88FD",
    fillOpacity: 0.76
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1357_7745",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1357_7745",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1357_7745",
    x1: 40,
    y1: 85,
    x2: 40,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1357_7745",
    x1: 40,
    y1: 85,
    x2: 40,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1357_7745",
    x1: 40,
    y1: 170,
    x2: 40,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1357_7745",
    x1: 40,
    y1: 170,
    x2: 40,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1357_7745",
    x1: 40,
    y1: 255,
    x2: 40,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1357_7745",
    x1: 40,
    y1: 255,
    x2: 40,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1357_7745",
    x1: 40,
    y1: 340,
    x2: 40,
    y2: 420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1357_7745",
    x1: 40,
    y1: 340,
    x2: 40,
    y2: 420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1357_7745",
    x1: 126,
    y1: 0,
    x2: 126,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1357_7745",
    x1: 126,
    y1: 0,
    x2: 126,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1357_7745",
    x1: 126,
    y1: 85,
    x2: 126,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1357_7745",
    x1: 126,
    y1: 85,
    x2: 126,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1357_7745",
    x1: 126,
    y1: 170,
    x2: 126,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1357_7745",
    x1: 126,
    y1: 170,
    x2: 126,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1357_7745",
    x1: 126,
    y1: 255,
    x2: 126,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1357_7745",
    x1: 126,
    y1: 255,
    x2: 126,
    y2: 335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1357_7745",
    x1: 126,
    y1: 340,
    x2: 126,
    y2: 420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1357_7745",
    x1: 126,
    y1: 340,
    x2: 126,
    y2: 420,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1357_7745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 420,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 420)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1357_7745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 420,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.856a5fd1a6366c6ae1787d338b9d66f3.svg";
export { ForwardRef as ReactComponent };